import type {ReactElement} from 'react';
import {Button, ButtonSize, ButtonType} from '@Components/button';
import {applyImageCrop, cancelImageCrop} from '@EmailMakerReact/lib/email-maker-image-crop-library';
import type {ImageCropActionsProps} from './image-crop-actions.types';

export function ImageCropActions({editor, idPrefix, isApplyButtonFullWidth = false}: ImageCropActionsProps): ReactElement {
  function handleCancel(): void {
    cancelImageCrop(editor);
  }

  function handleApply(): void {
    applyImageCrop(editor);
  }

  return (
    <>
      <Button type={ButtonType.SECONDARY} size={ButtonSize.MEDIUM} id={`${idPrefix}-cancel-button`} text={window.i18next.t('pmwjs_cancel')} onClick={handleCancel} />
      <Button
        type={ButtonType.PRIMARY}
        size={ButtonSize.MEDIUM}
        id={`${idPrefix}-apply-button`}
        text={window.i18next.t('pmwjs_apply')}
        isFullWidth={isApplyButtonFullWidth}
        onClick={handleApply}
      />
    </>
  );
}
